
    // ── SVG Chart helpers (pure functions) ──
    const COLORS = ['#3b82f6','#0d9488','#f59e0b','#16a34a','#ef4444','#7c3aed','#6366f1','#ec4899'];

    function svgDonut(data, size=180) {
      const r = size/2 - 10, cx = size/2, cy = size/2;
      const total = data.reduce((s,d) => s + d.value, 0);
      if (total === 0) return '<div style="text-align:center;color:#94a3b8;padding:2rem;">無資料</div>';
      let angle = -90, paths = '';
      data.forEach((d, i) => {
        const pct = d.value / total;
        if (pct <= 0) return;
        const a1 = angle * Math.PI / 180;
        angle += pct * 360;
        const a2 = angle * Math.PI / 180;
        const large = pct > 0.5 ? 1 : 0;
        const x1 = cx + r * Math.cos(a1), y1 = cy + r * Math.sin(a1);
        const x2 = cx + r * Math.cos(a2), y2 = cy + r * Math.sin(a2);
        paths += `<path d="M${cx},${cy} L${x1},${y1} A${r},${r} 0 ${large},1 ${x2},${y2} Z" fill="${d.color || COLORS[i % COLORS.length]}" opacity="0.85"/>`;
      });
      let legend = data.filter(d=>d.value>0).map((d,i) =>
        `<span class="leg"><span class="dot" style="background:${d.color || COLORS[i % COLORS.length]}"></span>${d.label} (${(d.value/total*100).toFixed(0)}%)</span>`
      ).join('');
      return `<div class="chart-wrap"><svg viewBox="0 0 ${size} ${size}" width="${size}" height="${size}">${paths}<circle cx="${cx}" cy="${cy}" r="${r*0.55}" fill="white"/></svg></div><div class="chart-legend">${legend}</div>`;
    }

    function svgStackedBar(segments, w=400, h=32) {
      const total = segments.reduce((s,d)=>s+d.value, 0);
      if (total <= 0) return '<div style="text-align:center;color:#94a3b8;">無逾期帳款</div>';
      let x = 0, svg = '';
      segments.forEach((seg, i) => {
        const pct = seg.value / total;
        const sw = Math.max(pct * w, pct > 0 ? 2 : 0);
        svg += `<rect x="${x}" y="0" width="${sw}" height="${h}" rx="${i===0?4:0}" fill="${seg.color || COLORS[i]}" opacity="0.8"/>`;
        if (pct >= 0.08) svg += `<text x="${x+sw/2}" y="${h/2+4}" text-anchor="middle" font-size="10" fill="white" font-weight="600">${(pct*100).toFixed(0)}%</text>`;
        x += sw;
      });
      let legend = segments.filter(s=>s.value>0).map((s,i) =>
        `<span class="leg"><span class="dot" style="background:${s.color||COLORS[i]}"></span>${s.label}</span>`
      ).join('');
      return `<div class="chart-wrap"><svg viewBox="0 0 ${w} ${h}" width="100%" preserveAspectRatio="xMinYMin meet" style="border-radius:4px;overflow:hidden;">${svg}</svg></div><div class="chart-legend">${legend}</div>`;
    }

    // ── Format helpers ──
    function fmt(v) { return 'NT$ ' + parseFloat(v).toLocaleString('zh-TW', {maximumFractionDigits: 0}); }
    function esc(s) { if (s == null) return ''; const d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    const STATUS_LABELS = {
      deposit_unpaid: '待收訂金', deposit_paid: '已付訂金',
      supplier_notified: '製作中', pending_collection: '待收款',
      fully_paid: '已收款', cancelled: '已取消',
    };

    // ── Check login & load dashboard ──
    async function initDashboard() {
      try {
        const res = await fetch('/api/dashboard/summary', { credentials: 'include' });
        if (!res.ok) return; // not logged in or error → show static page

        const d = await res.json();

        // Show dashboard (hero + workflow remain visible)
        document.getElementById('dashboardView').style.display = 'block';

        // ── Alerts ──
        const alertsEl = document.getElementById('dashAlerts');
        if (d.alerts && d.alerts.length > 0) {
          alertsEl.innerHTML = d.alerts.map(a => `
            <a class="dash-alert ${esc(a.severity)}" href="${esc(a.link)}">
              <span class="alert-icon">${a.severity === 'danger' ? '🔴' : '🟡'}</span>
              <div class="alert-text">
                <div class="alert-title">${esc(a.title)}</div>
                <div class="alert-msg">${esc(a.message)}</div>
              </div>
              <span class="alert-arrow">›</span>
            </a>
          `).join('');
        }

        // ── KPI ──
        document.getElementById('kpiSales').textContent = fmt(d.sales.month_total);
        if (d.sales.growth_pct !== null) {
          const cls = d.sales.growth_pct >= 0 ? 'up' : 'down';
          const arrow = d.sales.growth_pct >= 0 ? '↑' : '↓';
          document.getElementById('kpiSalesGrowth').innerHTML =
            `較上月 <span class="${cls}">${arrow} ${Math.abs(d.sales.growth_pct)}%</span>`;
        } else {
          document.getElementById('kpiSalesGrowth').textContent = '上月無數據';
        }

        document.getElementById('kpiAR').textContent = fmt(d.ar.total_outstanding);
        document.getElementById('kpiARSub').textContent =
          d.ar.overdue_count > 0 ? `${d.ar.overdue_count} 筆逾期` : '無逾期';

        const alertTotal = d.inventory.out_of_stock_count + d.inventory.low_stock_count;
        document.getElementById('kpiInventory').textContent = alertTotal > 0 ? alertTotal + ' 項' : '正常';
        document.getElementById('kpiInventorySub').textContent =
          `缺貨 ${d.inventory.out_of_stock_count} / 不足 ${d.inventory.low_stock_count}`;

        document.getElementById('kpiCount').textContent = d.sales.month_count;
        document.getElementById('kpiCountSub').textContent = '筆銷貨單';

        // ── AR Aging chart ──
        const arData = [
          { label: '未逾期', value: parseFloat(d.ar.not_due), color: '#10b981' },
          { label: '1-30天', value: parseFloat(d.ar.days_1_30), color: '#f59e0b' },
          { label: '31-60天', value: parseFloat(d.ar.days_31_60), color: '#f97316' },
          { label: '61-90天', value: parseFloat(d.ar.days_61_90), color: '#ef4444' },
          { label: '90天+', value: parseFloat(d.ar.days_over_90), color: '#991b1b' },
        ];
        document.getElementById('arAgingChart').innerHTML = svgDonut(arData);

        // ── Inventory chart ──
        const okCount = d.inventory.total_products - d.inventory.low_stock_count - d.inventory.out_of_stock_count;
        const invData = [
          { label: '充足', value: okCount, color: '#10b981' },
          { label: '不足', value: d.inventory.low_stock_count, color: '#f59e0b' },
          { label: '缺貨', value: d.inventory.out_of_stock_count, color: '#ef4444' },
        ];
        document.getElementById('inventoryChart').innerHTML = svgStackedBar(invData);

        // ── Recent invoices ──
        const tbody = document.getElementById('recentInvoicesBody');
        if (d.recent_invoices.length === 0) {
          tbody.innerHTML = '<tr><td colspan="5" style="text-align:center;color:#94a3b8;padding:2rem;">尚無銷貨單</td></tr>';
        } else {
          tbody.innerHTML = d.recent_invoices.map(inv => `
            <tr style="cursor:pointer" onclick="location.href='/src/pages/sales_invoices.html'">
              <td><strong>${esc(inv.invoice_number)}</strong></td>
              <td>${esc(inv.customer_name)}</td>
              <td class="text-right" style="font-weight:600;">${fmt(inv.total_amount)}</td>
              <td><span class="badge badge-${esc(inv.status)}">${STATUS_LABELS[inv.status] || inv.status}</span></td>
              <td>${esc(inv.invoice_date)}</td>
            </tr>
          `).join('');
        }

      } catch (e) {
        console.log('Dashboard load skipped:', e.message);
      }
    }

    // ── API health check ──
    async function checkApiConnection() {
      const statusEl = document.getElementById('api-status');
      const dotEl = document.getElementById('statusDot');
      try {
        const response = await fetch('/health');
        if (response.ok) {
          statusEl.textContent = 'API 連線正常';
          dotEl.classList.add('online');
        } else {
          throw new Error('API error');
        }
      } catch (error) {
        statusEl.textContent = 'API 連線失敗 - 請確認後端伺服器已啟動';
        dotEl.classList.add('offline');
      }
    }

    checkApiConnection();
    initDashboard();
  